<template>
    <div class="col-sm-12">
        <status-message v-model="statusMessage"></status-message>

        <h2>Custom questions</h2>

        <ul class="nav nav-tabs">
            <li v-for="group in groups" :class="{ active: group.active }">
                <a href="#" @click.prevent="changeActiveGroup(group)">
                    {{ group.name }}
                    <i v-if="group.id === null">(draft)</i>
                </a>
            </li>
            <li><a href="#" @click.prevent="addGroup()" v-if="! draftGroupExists">+ Add set</a></li>
        </ul>

        <div style="margin-bottom: 2rem" v-if="! activeGroup.default">
            <div class="row form-group">
                <div class="col-sm-2">
                    <label>Set name:</label>
                </div>
                <div class="col-sm-5">
                    <input type="text" class="form-control" v-model="activeGroup.name">
                </div>
                <div class="col-sm-5 text-right">
                    <button type="button" class="btn btn-secondary" @click.prevent="removeGroup(activeGroup)" >
                        <span aria-hidden="true" class="fa fa-times" style="padding-right: 5px;"></span>Delete set
                    </button>
                </div>
            </div>
            <div class="row form-group">
                <div class="col-sm-2">
                    <label>Job IDs:</label>
                </div>
                <div class="col-sm-5">
                    <input type="text" class="form-control" v-model="activeGroup.jobs">
                </div>
            </div>
        </div>

        <div class="clearfix"></div>

        <h3 style="margin-top: 4rem">Predefined questions</h3>

        <div class="row">
            <div class="col-sm-4" v-for="question in predefinedQuestions">
                <div class="checkbox" style="margin-top: 5px">
                    <label>
                        <input type="checkbox" v-model="question.active" :disabled="question.readonly" @change="! question.active"> {{ question.text }}
                    </label>
                </div>
            </div>
        </div>

        <h3 style="margin-top: 4rem">All questions</h3>

        <form>
            <div class="table-responsive">
                <table class="table table-striped table-hover">
                    <thead>
                        <tr>
                            <th style="width: 5%"></th>
                            <th style="width: 15%">Key(s)</th>
                            <th style="width: 32%">Question</th>
                            <th style="width: 30%">Options</th>
                            <th></th>
                        </tr>
                    </thead>
                    <draggable v-model="activeQuestions" tag="tbody" handle=".handle">
                        <tr v-for="(question, index_q) in activeQuestions">
                            <td>
                                <button type="button" class="btn btn-secondary handle">
                                    <i class="fa fa-bars" aria-hidden="true"></i>
                                </button>
                            </td>
                            <td>
				                <input type="text" class="form-control" v-model="question.key" :readonly="question.type === 'predefined'">
                            </td>
                            <td>
				                <input type="text" class="form-control" v-model="question.text">

                                <div v-if="question.type !== 'predefined'" class="checkbox" style="margin-top: 15px">
                                    <label>
                                        <input type="checkbox" v-model="question.include_tenstreet_display_fields"> Include Tenstreet display fields
                                    </label>
                                </div>

                                <p v-else-if="question.comment" class="form-control-static">
                                    <i>{{ question.comment }}</i>
                                </p>
                            </td>
                            <td>
                                <template v-if="question.type === 'dropdown' || question.type === 'checkboxes'">
                                    <div class="row" v-for="(option, index_o) in question.options">
                                        <div class="col-sm-9">
                                            <div class="form-group">
                                                <div class="input-group">
                                                    <div class="input-group-addon" style="background: transparent; border: 0">
                                                        <template v-if="question.type === 'dropdown'">
                                                            <i class="fa fa-caret-square-o-down" aria-hidden="true"></i>
                                                        </template>
                                                        <template v-else-if="question.type === 'checkboxes'">
                                                            <i class="fa fa-check-square-o" aria-hidden="true"></i>
                                                        </template>
                                                    </div>
                                                    <input type="text" class="form-control" v-model="option.text">
                                                    <div class="input-group-addon">
                                                        <a href="#" class="text-danger" @click.prevent="removeOption(question, index_o)">
                                                            <span class="fa fa-times" aria-hidden="true"></span>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-3">
                                            <div class="checkbox" style="margin-top: 5px">
                                                <label>
                                                    <input type="checkbox" v-model="option.block"> Block
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    <button type="button" class="btn btn-secondary btn-sm" @click="addOption(question)" style="margin-left: 3.6rem">
                                        <span class="fa fa-plus" aria-hidden="true"></span>
                                        Add option
                                    </button>
                                </template>
                                <p v-else-if="question.type === 'text'" class="form-control-static">
                                    <i>Text field</i>
                                </p>
                                <p v-else class="form-control-static">
                                    <i>Predefined</i>
                                </p>
                            </td>
                            <td class="text-right" style="padding-right: 2rem">
                                <a href="#" class="text-danger" @click.prevent="removeQuestion(question)" v-if="question.readonly === false">
                                    <span class="fa fa-times" aria-hidden="true" style="padding-right: 5px"></span>Delete question</a>
                            </td>
                        </tr>
                    </draggable>
                </table>
            </div>

            <button type="button" class="btn btn-secondary btn-sm" @click="addQuestion('dropdown')">
                <span class="fa fa-plus" aria-hidden="true"></span>
                Add dropdown question
            </button>

            <button type="button" class="btn btn-secondary btn-sm" @click="addQuestion('checkboxes')" style="margin-left: 1rem">
                <span class="fa fa-plus" aria-hidden="true"></span>
                Add question with checkboxes
            </button>

            <button type="button" class="btn btn-secondary btn-sm" @click="addQuestion('text')" style="margin-left: 1rem">
                <span class="fa fa-plus" aria-hidden="true"></span>
                Add text question
            </button>

            <div class="clearfix" style="margin-bottom: 5rem"></div>
            <busy-spinner :is-on="isBusy"></busy-spinner>
            <button type="submit" class="btn btn-danger" @click.prevent="save()">
				<span class="glyphicon glyphicon-save" aria-hidden="true"></span>
				Save "{{ activeGroup.name }}" custom questions
			</button>
        </form>

        <employer-notes-wrapper :employer-id="employerId" />
    </div>
</template>

<script>
    export default {
        props: [
            'data',
            'employerId',
        ],
        data() {
            return {
                employer: this.data.employer,
                defaultPredefinedQuestions: this.data.defaultPredefinedQuestions,
                groups: this.data.groups,
            };
        },
        computed: {
            'predefinedQuestionsDefault': function () {
                var predefinedQuestionsDefault = _.filter(this.activeGroup.questions, { 'type': 'predefined' });

                return _.sortBy(predefinedQuestionsDefault, ['checkbox_order']);
            },
            'activeGroup': function () {
                return _.first(_.filter(this.groups, { 'active': true }));
            },
            'draftGroupExists': function () {
                return _.filter(this.groups, { 'id': null }).length > 0;
            },
            'activeQuestions': {
                get: function () {
                    return _.filter(this.activeGroup.questions, { 'active': true });
                },
                set: function (sortedActiveQuestions) {
                    var allQuestions = sortedActiveQuestions;

                    var remainingQuestions = _.filter(this.activeGroup.questions, { 'active': false })
                    _.forEach(remainingQuestions, function(q) {
                        allQuestions.push(q);
                    });

                    this.activeGroup.questions = allQuestions;
                }
            },
            'predefinedQuestions': function () {
                var predefinedQuestions = _.filter(this.activeGroup.questions, { 'type': 'predefined' });

                return _.sortBy(predefinedQuestions, ['checkbox_order']);
            }
        },
        mounted: function () {
            this.addPlaceholderQuestionIfNoQuestionPresent();
        },
        methods: {
            getActiveGroupIndex: function () {
                return _.findIndex(this.groups, { 'active': true });

            },
            changeActiveGroup: function (group) {
                _.forEach(this.groups, function(g) {
                    g.active = false;
                });

                if(group === null) {
                    group = _.first(this.groups);
                }

                // this.hideStatusMessages();
                group.active = true;
            },
            addGroup: function () {
                _.forEach(this.groups, function(g) {
                    g.active = false;
                });

                this.groups.push({
                    id: null,
                    name: 'New set',
                    active: true,
                    questions: _.cloneDeep(this.defaultPredefinedQuestions),
                    jobs: ''
                });

                this.addPlaceholderQuestionIfNoQuestionPresent();
            },
            removeGroup: function (group) {
                let r = confirm('Are you sure you want to delete this set of questions: "' + group.name + '"?');
                if (r !== true) {
                    return false;
                }

                // If already saved group (= has an ID), then delete it on server first
                if(group.id !== null) {
                    let url = window.url('admin/employer/' + this.employer.id + '/custom-questions/' + group.id + '/delete');
                    this.makePost(url, {}, 
                        (response) => {
                            this.showSuccess('Group of custom questions has been deleted.');
                        }
                    );
                }

                this.scrollTo(250);

                // Remove it from array on frontend
                group.active = null;

                _.remove(this.groups, function(g) {
                    return g.active === null;
                });

                this.changeActiveGroup(null);
            },
            addPlaceholderQuestionIfNoQuestionPresent: function () {
                if(this.activeGroup.id !== null) {
                    return;
                }

                let nonPredefinedQuestions = _.filter(this.activeGroup.questions, function(q) {
                    return q.type !== 'predefined';
                });

               if(nonPredefinedQuestions.length == 0) {
                    this.addQuestion('dropdown');
                }
            },

            addQuestion: function (type) {
                var new_question = {
                    key: null,
                    type: type,
                    text: '',
                    options: null,
                    include_tenstreet_display_fields: true,
                    active: true,
                    readonly: false
                }

                if(type === 'dropdown') {
                    new_question.options = [
                        {
                            'text': 'Yes',
                            'block': false,
                        },
                        {
                            'text': 'No',
                            'block': false,
                        }
                    ];
                } else if(type === 'checkboxes') {
                    new_question.options = [
                        {
                            'text': '',
                            'block': false,
                        },
                    ];
                }

                this.activeGroup.questions.push(new_question);
            },
            removeQuestion: function (question) {
                if(question.type === 'predefined') {
                    question.active = false;
                } else {
                    question.active = null;

                    _.remove(this.activeGroup.questions, function(q) {
                        return q.active === null;
                    });
                }
            },
            addOption: function (question) {
                question.options.push({ text: '', block: false });
            },
            removeOption: function (question, index_o) {
                question.options.splice(index_o, 1);
            },
            validate: function () {
                // Check for empty keys, questions and options
                var empty_fields = false;

                this.activeQuestions.forEach(function(question, index) {
                    if(! question.key || ! question.text) {
                        empty_fields = true;
                    }

                    if(question.type === 'dropdown' || question.type === 'checkboxes') {
                        if(! question.options.length === 0) {
                            empty_fields = true;
                        } else {
                            question.options.forEach(function(option) {
                                if(! option.text) {
                                    empty_fields = true;
                                }
                            });
                        }
                    }
                });

                if(empty_fields === true) {
                    this.showError('Please fill in Key, Question and Options for all the listed questions.');

                    return false;
                }

                // Check for duplicate keys
                var enteredKeys = [];
                var duplicateKeys = [];
                _.forEach(this.activeQuestions, function(question, index) {
                    var questionKeys = [question.key];

                    // Predefined questions may have multiple keys
                    if(question.type === 'predefined') {
                        questionKeys = question.key.split(',');
                    }

                    _.forEach(questionKeys, function(key, index) {
                        var normalizedKey = key.toLowerCase().trim();

                        if(enteredKeys.indexOf(normalizedKey) === -1) {
                            enteredKeys.push(normalizedKey);
                        } else {
                            duplicateKeys.push(key);
                        }
                    });
                });

                if(duplicateKeys.length > 0) {
                    duplicateKeys = _.uniq(duplicateKeys);

                    this.showError('Duplicate key(s): ' + duplicateKeys.join(', ') + '.');

                    return false;
                }

                return true;
            },
            save: function () {
                if(! this.validate()) {
                    this.scrollTo(250);

                    return false;
                }

                let url = window.url('admin/employer/' + this.employer.id + '/custom-questions');

                this.makePost(url, {
                    group: this.activeGroup
                }, 
                    (response) => {
                        if(response.group) {
                            this.groups[this.getActiveGroupIndex()].id = response.group.id;
                            this.groups[this.getActiveGroupIndex()].name = response.group.name;
                            this.groups[this.getActiveGroupIndex()].questions = response.group.questions;
                            this.groups[this.getActiveGroupIndex()].jobs = response.group.jobs;
                        }

                        this.showSuccess('Group "' + response.group.name +'" has been saved.');
                    }
                );

                this.scrollTo(250);
            },
            scrollTo: function (top) {
                window.scrollTo({
                    top: top,
                    left: 0,
                    behavior: 'smooth'
                });
            }
        }
    }
</script>

<style>
    .handle { cursor: move; }
</style>
